const COUNTRIES = ["Australia", "United Kingdom", "France", "Canada", "USA", "South Africa"];

export default function Markets() {
  // Duplicate for seamless loop
  const items = [...COUNTRIES, ...COUNTRIES, ...COUNTRIES];
  return (
    <section
      data-testid="markets-marquee"
      className="relative bg-[var(--ink)] text-[var(--bone)] border-y border-[var(--bone)]/10 overflow-hidden"
    >
      <div className="absolute inset-y-0 left-0 w-32 md:w-64 bg-gradient-to-r from-[var(--ink)] to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 md:w-64 bg-gradient-to-l from-[var(--ink)] to-transparent z-10 pointer-events-none" />

      <div className="py-10 md:py-14">
        <div className="text-overline text-[var(--gold)] text-center mb-6">
          Currently speaking with families in
        </div>
        <div className="marquee-track">
          {items.map((c, i) => (
            <div
              key={`${c}-${i}`}
              className="flex items-center gap-12 md:gap-20 pr-12 md:pr-20 shrink-0"
            >
              <span className="font-serif-display italic text-3xl md:text-5xl lg:text-[3.4rem] leading-none whitespace-nowrap text-[var(--bone)]/95">
                {c}
              </span>
              <span className="text-[var(--gold)] text-2xl md:text-4xl">·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
